import { Outlet } from 'react-router-dom'

/** Root layout — route shells (home, modules, project) render into the outlet. */
export default function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Outlet />
    </div>
  )
}
